<form class="flex flex-col flex-[1_1_100%] gap-[15px]" #screenLockerForm="ngForm" class="locker">
  <div class="flex flex-row flex-[1_1_100%] justify-center items-center title-row">
    <div class="flex flex-col justify-center items-center flex-[1_1_100%]">
      {{'COUNTER IS LOCKED'}}
    </div>
  </div>
  <div class="flex flex-row flex-[1_1_100%] justify-center items-center">
    <mat-form-field appearance="fill">
      <mat-label>{{'Pin code' | translate}}</mat-label>
      <input matInput [type]="type" [formControl]="pinCodeCtrl" name="pinCode" autocomplete="off" (keydown.enter)="findCode()">
      @if (pinCodeCtrl.valid) {
        <mat-icon matSuffix class="ask" (click)="toggleVisiblity($event)">{{icon}}</mat-icon>
      }
      @if (pinCodeCtrl.hasError('notExist')) {
        <mat-icon color='warn' matSuffix>report</mat-icon>
      }
      <mat-error>
        {{'Invalid Pin Code' | translate}}
      </mat-error>
    </mat-form-field>
    <button mat-icon-button color="primary" (click)="findCode()" class="find-btn">
      <mat-icon>done_outline</mat-icon>
    </button>
  </div>
</form>
